import React, { useCallback, useState } from "react";
import "./MobileHeader.scss";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../../../static/icons/logo-SaveOffice.svg";
import { performConversionScript } from "../../../shared/ConversionHelper";

const SCROLL_DELTA_THRESHOLD = 6;
const HIDE_TRIGGER_Y = 56;

const MobileHeader = () => {
  const [headerCollapse, setHeaderCollapse] = useState(false);
  const [collapse, setCollapse] = useState(true);
  const collapseRef = React.useRef(collapse);
  const lastScrollYRef = React.useRef(0);
  const rafIdRef = React.useRef<number | null>(null);

  const toggleCollapse = useCallback(() => {
    setCollapse((prev) => !prev);
  }, []);
  const location = useLocation();
  const logoPath = "/";
  const privateOfficeLinkTarget = "/private-office";

  React.useEffect(() => {
    collapseRef.current = collapse;
    lastScrollYRef.current = window.scrollY;

    if (!collapse) {
      setHeaderCollapse(false);
    }
  }, [collapse]);

  React.useEffect(() => {
    function onScroll() {
      if (!collapseRef.current || rafIdRef.current != null) {
        return;
      }

      rafIdRef.current = window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollYRef.current;

        if (Math.abs(delta) >= SCROLL_DELTA_THRESHOLD) {
          setHeaderCollapse((prev) => {
            if (delta > 0 && currentScrollY > HIDE_TRIGGER_Y) {
              return true;
            }
            if (delta < 0 || currentScrollY <= 0) {
              return false;
            }
            return prev;
          });
        }

        lastScrollYRef.current = currentScrollY;
        rafIdRef.current = null;
      });
    }

    lastScrollYRef.current = window.scrollY;
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafIdRef.current != null) {
        window.cancelAnimationFrame(rafIdRef.current);
      }
    };
  }, []);

  return (
    <>
      <header
        className={`mobile-header ${collapse ? "collapse_" : "expand_"} ${
          headerCollapse ? "header-collapse_" : ""
        }`}
        id={"mobile-header"}
      >
        <div className="gnb">
          <Link
            to={logoPath}
            className="logo"
            onClick={() => window.scrollTo({ top: 0 })}
          >
            <Logo width={134} />
          </Link>
          <button onClick={toggleCollapse} className="menu-toggle">
            <div className="toggle-icon">
              <span />
              <span />
            </div>
          </button>
        </div>
        <nav className="mobile-nav">
          <ul>
            {/* <a href="/offer" onClick={toggleCollapse}>
              <li>제공 서비스</li>
            </a> */}
            <a href="/benefits" onClick={toggleCollapse}>
              <li>베네핏 서비스</li>
            </a>
            <a href="/price" onClick={toggleCollapse}>
              <li>비용 안내</li>
            </a>
            <a href="/manual" onClick={toggleCollapse}>
              <li>이용 방법</li>
            </a>
            <a href="/union" onClick={toggleCollapse}>
              <li>결합 서비스</li>
            </a>
            <Link to="/promotion" onClick={toggleCollapse}>
              <li>프로모션</li>
            </Link>
            <Link to="/faq" onClick={toggleCollapse}>
              <li>자주 묻는 질문</li>
            </Link>
          </ul>
          <ul>
            <Link to={privateOfficeLinkTarget} onClick={toggleCollapse}>
              <li>
                <img src={require("../../../static/office2.png")} />
                상주 사무실
              </li>
            </Link>
          </ul>
          <ul>
            <Link to="/location">
              <li>
                <img src={require("../../../static/location2.png")} />
                위치 안내
              </li>
            </Link>
          </ul>
          <ul>
            <Link
              to={`/consult${location.search}`}
              onClick={performConversionScript}
            >
              <li>
                <img src={require("../../../static/message2.png")} />
                지금 신청하기
              </li>
            </Link>
          </ul>
        </nav>
      </header>
      <div
        className={`mobile-header-overlay ${collapse ? "" : "visible"}`}
        onClick={toggleCollapse}
      />
    </>
  );
};

export default MobileHeader;
